var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('validation-provider',{attrs:{"rules":"required|url","vid":'answers.'+ _vm.index + '.url_answer'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var valid = ref.valid;
return [_c('v-text-field',{attrs:{"error-messages":errors,"rounded":"","filled":""},on:{"input":_vm.emitAnswer},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }